const REASON_NAMES = ['INACCURATE', 'UNCLEAR', 'TOO_LONG', 'LACK_OF_IMPORTANT_INFO', 'OTHER'] as const;

export type Reason = typeof REASON_NAMES[number];

const REASON_IDS: Record<Reason, number> = {
    INACCURATE: 1,
    UNCLEAR: 2,
    TOO_LONG: 3,
    LACK_OF_IMPORTANT_INFO: 4,
    OTHER: 5
};

const REASON_TRANSLATION_KEYS: Record<Reason, string> = {
    INACCURATE: 'aichat.feedback.reasons.inaccurate',
    UNCLEAR: 'aichat.feedback.reasons.unclear',
    TOO_LONG: 'aichat.feedback.reasons.too_long',
    LACK_OF_IMPORTANT_INFO: 'aichat.feedback.reasons.lacks_info',
    OTHER: 'aichat.feedback.reasons.other'
};

export interface ReasonItem {
    id: number;
    label: string;
}

export const REASONS: ReasonItem[] = REASON_NAMES.map((name) => ({
    id: REASON_IDS[name],
    label: REASON_TRANSLATION_KEYS[name]
}));
